import { useFormik } from "formik"
import PropTypes from "prop-types"
import React, { useContext, useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row
} from "reactstrap"
import * as Yup from "yup"

//Import Breadcrumb
import Breadcrumbs from "components/Common/BreadcrumbTitle"

import CommonDialog from "components/Common/CommonDialog"
import { addSubCategory, editSubCategory, getCategoryList, getOneSubCategory } from "helpers/UAM/subCategory.helper"
import { useToast } from "ToastStore";
import ToastDialog from "components/Common/ToastDialog";
import { SystemConfigurationContext } from "context/systemConfigContext"

const AddSubCategory = props => {

  const navigate = useNavigate()
  const {inputMax} = useContext(SystemConfigurationContext)

  const location = useLocation();
  const pathnameSegments = location.pathname.split('/');
  const lastSegment = pathnameSegments[pathnameSegments.length - 1];

  //meta title
  let formattedLastSegment = lastSegment.charAt(0).toUpperCase() + lastSegment.slice(1).toLowerCase();

  document.title = `${formattedLastSegment} Sub Category | DMS`

  const urlParams = new URLSearchParams(window.location.search);
  const encodedId = urlParams.get("id");
  const decodedId = atob(encodedId);

  const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
  const [subCategoryList, setSubCategoryList] = useState({})
  const [showViewTemplate, setShowViewTemplate] = useState(false);
  const [showEditTemplate, setShowEditTemplate] = useState(true);
  const [categoryList, setCategoryList] = useState([])
  const { handleToastData } = useToast();
const [toastInfo, setToastInfo] = useState({ showToast: false });


  useEffect(() => {
    if (lastSegment == "view" || lastSegment == "edit") {
      getOneSubCategory({ id: decodedId })
        .then(responseFromAPI => {
          if (responseFromAPI.status && responseFromAPI.code == 200) {
            let responseData = responseFromAPI.data[0]
            setSubCategoryList(responseData)
          }
        })
        .catch(error => { })


    }

    if (lastSegment == "view") {
      setShowViewTemplate(true)
      setShowEditTemplate(false)
    } else {
      setShowViewTemplate(false)
      setShowEditTemplate(true)
    }

    getCategoryList()
      .then((response) => {
        if (response.status && response.code == 200) {
          setCategoryList(response?.data.data)

        }
      })
      .catch((error) => {
        console.log(error)
      })
  }, []);

  // validation
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      subCategoryName: subCategoryList.subCategoryName || "",
      subCategoryCode: subCategoryList.subCategoryCode || "",
      subCategoryDescription: subCategoryList.subCategoryDescription || "",
      categoryId: (subCategoryList.categoryId) || ""
    },
    validationSchema: Yup.object({
      subCategoryName: Yup.string().required("Please Enter  Sub Category Name"),
      subCategoryCode: Yup.string().required("Please Enter Sub Category Code"),
      categoryId: Yup.string().required("Please select a category"),
    }),
    onSubmit: values => {

      const message = lastSegment == 'edit' ? 'Are you sure want to update Sub Category?' : 'Do you want to save entry?'
      setShowCommonDialog({ isShow: true, message: message })

    },
  })

  const navigateBack = () => {
    navigate(-1)
  }

  const dialogAction = (action, data) => {
    if (action == 1) {
      setShowCommonDialog({ isShow: false })
      upsertSubCategory()

    } else {
      setShowCommonDialog({ isShow: false })
    }
  }

  const upsertSubCategory = () => {
    const { values } = validation
    if (lastSegment == "edit") {
      let arr = []
      const updateSubCategoryData = {
        subCategoryName: values.subCategoryName,
        subCategoryCode: values.subCategoryCode,
        subCategoryDescription: values.subCategoryDescription,
        categoryId: values.categoryId,
      }
      arr.push(updateSubCategoryData)
      editSubCategory({ subcategory: arr })
        .then(responseFromAPI => {
          if (responseFromAPI.status && responseFromAPI.code == 201) {
            handleToastData(responseFromAPI.message, "success")
            navigate("/admin/listSubCategory");
          }else{
            setToastInfo({
              message: responseFromAPI.message,
              showToast: true,
              role: "error",
          });
          }
        })
        .catch(error => { })
      validation.resetForm()
    } else {
      const newSubCategory = {
        subCategoryName: values.subCategoryName,
        subCategoryCode: values.subCategoryCode,
        subCategoryDescription: values.subCategoryDescription,
        categoryId: values.categoryId
      }
      let arr = []
      arr.push(newSubCategory)
      addSubCategory({ subcategory: arr })
        .then(responseFromAPI => {
          if (responseFromAPI.status && responseFromAPI.code == 201) {
            handleToastData(responseFromAPI.message, "success")
            navigate("/admin/listSubCategory");
          }else{
            setToastInfo({
              message: responseFromAPI.message,
              showToast: true,
              role: "error",
          });
          }
        })
        .catch(error => { })

      validation.resetForm()
    }
  }


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={`${lastSegment.toUpperCase()} Sub Category`} />
          <Row className="vertical-scroll">
            <Col xs="12">
              <Card>
                <CardBody>
                  {showEditTemplate && (<Form
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >

                    <Row className="mb-4">
                      <Col sm={6}>
                        <Label className="mt-2">Select Category *</Label>
                        <Input
                          maxLength={inputMax}
                          name="categoryId"
                          type="select"
                          placeholder="Select Category"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.categoryId || ""}
                          invalid={
                            validation.touched.categoryId && validation.errors.categoryId
                          }
                        >
                          <option value="" disabled>
                            Choose a Category
                          </option>
                          {categoryList.map((elem) => (
                            <option key={elem.id} value={elem.id} >
                              {elem.categoryName}
                            </option>
                          ))}
                        </Input>
                        {validation.touched.categoryId && validation.errors.categoryId ? (
                          <FormFeedback type="invalid">
                            {validation.errors.categoryId}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col sm={6}>
                        <Label
                          htmlFor="horizontal-email-Input"
                          className="col-sm-7 col-form-label"
                        >
                          SubCategory Code *
                        </Label>
                        <Input
                          maxLength={inputMax}
                          name="subCategoryCode"
                          type="text"
                          placeholder="Enter subcategory Code"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.subCategoryCode || ""}
                          invalid={
                            validation.touched.subCategoryCode &&
                            validation.errors.subCategoryCode
                          }
                        />
                        {validation.touched.subCategoryCode &&
                          validation.errors.subCategoryCode ? (
                          <FormFeedback type="invalid">
                            {validation.errors.subCategoryCode}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col sm={6}>
                        <Label
                          htmlFor="horizontal-email-Input"
                          className="col-sm-6 col-form-label"
                        >
                          SubCategory Name *
                        </Label>
                        <Input
                          maxLength={inputMax}
                          name="subCategoryName"
                          type="text"
                          placeholder="Enter subcategory Name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.subCategoryName || ""}
                          invalid={
                            validation.touched.subCategoryName &&
                            validation.errors.subCategoryName
                          }
                        />
                        {validation.touched.subCategoryName &&
                          validation.errors.subCategoryName ? (
                          <FormFeedback type="invalid">
                            {validation.errors.subCategoryName}
                          </FormFeedback>
                        ) : null}
                      </Col>


                      <Col sm={6}>
                        <Label className="mt-2">SubCategory Description</Label>
                        <Input
                          maxLength={inputMax}
                          name="subCategoryDescription"
                          type="textarea"
                          placeholder="Enter subcategory Description"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.subCategoryDescription || ""}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <div className="text-end">
                          <button
                            type="submit"
                            className="btn btn-success save-customer"
                          >
                            Save
                          </button>
                          <button
                            type="submit"
                            className="btn btn-outline-secondary"
                            style={{ marginLeft: "7px" }}
                            onClick={() => {
                              navigateBack();
                            }
                            }
                          >
                            Back
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                  )}
                  {showViewTemplate && <div>
                    <Row>
                      <Col sm={4}>
                        <Label
                          className="col-sm-6 col-form-label label label-styling"
                        >
                          Category Name
                        </Label>
                        <p>{subCategoryList?.category?.categoryName || "-"}</p>
                      </Col>
                      <Col sm={4}>
                        <Label
                          className="col-sm-6 col-form-label label label-styling"
                        >
                          Subcategory Code
                        </Label>
                        <p >{subCategoryList.subCategoryCode || "-"}</p>
                      </Col>
                      <Col sm={4}>
                        <Label
                          className="col-sm-6 col-form-label label label-styling"
                        >
                          Subcategory Name
                        </Label>
                        <p>{subCategoryList.subCategoryName || "-"}</p>
                      </Col>
                    </Row>
                    <Row className="mb-4">
                      <Col sm={12}>
                        <Label
                          htmlFor="horizontal-notification-Input"
                          className="col-sm-6 col-form-label label label-styling"
                        >
                          Subcategory Description
                        </Label>
                        <p>{subCategoryList.subCategoryDescription || "-"}</p>
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <div>
                          <button
                            className="btn btn-outline-secondary"
                            onClick={() => {
                              navigateBack()
                            }}
                          >
                            Back
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </div>}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      {showCommonDialog &&
        <CommonDialog isShow={showCommonDialog.isShow} message={showCommonDialog.message} data={showCommonDialog.data} postitiveBtn={'Submit'} negativeBtn={'Close'} onCloseFn={dialogAction}></CommonDialog>
      }
      <ToastDialog
        message={toastInfo.message}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      />
    </React.Fragment>
  )
}

AddSubCategory.propTypes = {
  history: PropTypes.object,
}

export default AddSubCategory
